

export type HexColorValue = string | null;

